export default __webpack_public_path__ + "static/media/Pedro_Garza.2d11dac9.png";